///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/models/model.ts" />
namespace TotalContest {
    import Model = TotalCore.Common.Models.Model;

    export class Entry extends Model {

        constructor(attrs) {
            super(attrs);

            this.set('details', this.flatten(this.get('details', {})));
        }

        getAction() {
            return this.get('action');
        }

        getContestEditLink() {
            return this.get('contest.admin.editLink');
        }

        getContestTitle() {
            return this.get('contest.title');
        }

        getDate() {
            return this.get('date');
        }

        getDetails() {
            return this.get('details', {});
        }

        getIP() {
            return this.get('ip');
        }

        getStatus() {
            return this.get('status');
        }

        getSubmissionEditLink() {
            return this.get('submission.admin.editLink');
        }

        getSubmissionTitle() {
            return this.get('submission.title');
        }

        getUser(field?) {
            if (field) {
                return this.get(`user.${field}`);
            }

            return this.get('user');
        }

        getUseragent() {
            return this.get('useragent');
        }

        isAccepted() {
            return this.getStatus() === 'Accepted';
        }

        isRejected() {
            return this.getStatus() === 'Rejected';
        }

        private flatten(data) {
            var result = {};

            function recurse(cur, prop) {
                if (Object(cur) !== cur) {
                    result[prop] = cur;
                } else if (Array.isArray(cur)) {
                    for (var i = 0, l = cur.length; i < l; i++)
                        recurse(cur[i], prop + "[" + i + "]");
                    if (l == 0)
                        result[prop] = [];
                } else {
                    var isEmpty = true;
                    for (var p in cur) {
                        isEmpty = false;
                        recurse(cur[p], prop ? prop + "." + p : p);
                    }
                    if (isEmpty && prop)
                        result[prop] = {};
                }
            }

            recurse(data, "");
            return result;
        }
    }
}